export default __webpack_public_path__ + "static/media/poke-spell-ice-time.6c5de571.jpeg";